import { Col, Row } from "react-bootstrap";
import { Line } from 'rc-progress';
import { useContext } from "react";
import { ProfileContext } from "pages/Profile";

export default function Pathways() {

  const { profile } = useContext(ProfileContext)
  const getRandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

  const pathways = [
    {
      pathwayName: 'Humorous Speeches',
      progress: getRandomNumber(1, 100)
    },
    {
      pathwayName: 'Innovative Planning',
      progress: getRandomNumber(1, 100)
    }
  ]

  if (profile.acl === 'Guest') {
    return null
  }

  else {
    return (
      <Col>
        <h3 className="mt-1 mb-4">Pathways progress</h3>
        {
          pathways.map((pathway) => (
            <div key={pathway.pathwayName}>
              <Row>
                <Col>
                  <p>{pathway.pathwayName} </p>
                </Col>
                <Col>
                  <p className='text-end'>{pathway.progress}%</p>
                </Col>
              </Row>
              <Row className='mb-5'>
                <Col >
                  <Line percent={pathway.progress} strokeWidth={2} strokeColor="#00A261" />
                </Col>
              </Row>
            </div>
          ))
        }
      </Col>
    )
  }
}